import {
  Card,
  CardActions,
  CardContent,
  styled,
  Typography,
} from '@mui/material';
import { ReactNode } from 'react';

type BlockWidgetProps = {
  text: string;
  actions?: ReactNode;
  className?: string;
};

export function BlockWidget({ text, actions, className }: BlockWidgetProps) {
  return (
    <Card className={className}>
      <Block>
        <QuoteBar />
        <Typography variant="body1">{text}</Typography>
      </Block>
      {!!actions && <CardActions>{actions}</CardActions>}
    </Card>
  );
}

const QuoteBar = styled('div')`
  background-color: ${({ theme }) => `${theme.palette.primary.light}`};
  border-radius: 4px;
  min-width: 4px;
`;

const Block = styled(CardContent)`
  display: flex;
  gap: 12px;
`;
